// extracted by mini-css-extract-plugin
module.exports = {"admin_page_layout__main_container":"Layout_admin_page_layout__main_container__2iw5I"};